import { Card, CardBody, Col } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { FaqWidgetsData } from "../../../Data/Miscellaneous/FAQ";
import { Fragment } from "react/jsx-runtime";

const FaqWidgets = () => {
  return (
    <Fragment>
      {FaqWidgetsData.map((data) => (
        <Col xl="4" className={data.colClass} key={data.id}>
          <Card className="bg-primary articles-cards">
            <CardBody>
              <div className="d-flex faq-widgets">
                <div className="flex-grow-1">
                  <H4>{data.title}</H4>
                  <P>{data.paragraph}</P>
                </div>
                {data.icon}
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};
export default FaqWidgets;
